/**
 * 系统登录
 */

import request from "@/service/request";

// 用户登录
export async function login(params) {
  return await request.post("/auth/login", params);
}

// 用户注册
export async function register(params) {
  return await request.post("/auth/register", params);
}

// 用户退出
export async function logout() {
  return await request.post("/auth/logout");
}

// 注册验证码
export async function emailCodeRegister(params) {
  return await request.post("/auth/email_code_register", params);
}

// 用户注册
export async function forget(params) {
  return await request.post("/auth/forget", params);
}

// 忘记密码验证码
export async function emailCodeForget(params) {
  return await request.post("/auth/email_code_forget", params);
}
